import React from "react";
import { useParams } from "react-router-dom";
import { usePermissionGuardRedirect } from "../../../../hooks/usePermissionGuard";
import { GetExamPeriodAuditFilters, GetExamPeriodAuditTrails } from "../../../../services/ExternalExamServices";
import AuditTrailsTable from "../../../common/AuditTrailsTable";

function ExamPeriodAuditTrail() {
  const { subTab } = useParams();
  const columnsToShow = ["Action Type", "Resource Type", "Resource Name"];

  usePermissionGuardRedirect(['eeepview']);

  return (
    <AuditTrailsTable 
      apiFunction={GetExamPeriodAuditTrails}
      filterArrApi={GetExamPeriodAuditFilters}
      columnsToShow={columnsToShow}
      exportFileName={"Exam_Period_Audit_Trail"}
      isResourceNameShown={true}
      apiParams={{action_id: subTab}}
      actionId={subTab}
      isShowingResourceTypeFilter
    />
  );
}

export default ExamPeriodAuditTrail;
